import { useState } from "react";

import { FeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { m } from "@vega-core/paraglide/messages";
import { LPPageContainerWithNavigation } from "@vega-modules/components/PageContainerWithNavigation/PageContainerWithNavigation";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CoInvestmentFullPaths, CommonPaths } from "@vega-modules/paths";
import { ConversationsList } from "@vega-modules/scenes/CoInvestments/messaging/ConversationsList";

import { NotificationsDealFilterDropdown } from "../components/NotificationsDealFilterDropdown/NotificationsDealFilterDropdown";

export const LpMessagesPage = () => {
  useFeatureFlagGuard(
    FeatureFlag.COINVEST_MESSAGING_VD_28584,
    CommonPaths.Home,
  );

  const [dealOpportunityId, setDealOpportunityId] = useState<string>();

  return (
    <LPPageContainerWithNavigation showNavbar={false}>
      <div className="p-4 lg:p-8">
        <div>
          <h4 className="text-text/primary heading-4">
            {m.coInvestments_messages_title()}
          </h4>
          <p className="mt-1 body-base-regular text-text/secondary">
            {m.coInvestments_messages_lp_subtitle()}
          </p>
        </div>

        <div className="mt-4 flex flex-col gap-6">
          <NotificationsDealFilterDropdown
            onChange={setDealOpportunityId}
            value={dealOpportunityId}
          />

          <ConversationsList
            buildConversationPath={(conversation) =>
              CoInvestmentFullPaths.CoInvestmentLpConversation.replace(
                ":conversationId",
                conversation.id,
              )
            }
            buildItemTestId={(conversation) =>
              `coinvest-lp-conversation-${conversation.id}`
            }
            errorTestId="coinvest-lp-messages-error"
            listTestId="coinvest-lp-messages-list"
            metaFilter={dealOpportunityId ? { dealOpportunityId } : undefined}
          />
        </div>
      </div>
    </LPPageContainerWithNavigation>
  );
};
